export var wrap = {
  '& .input': {
    margin: 0
  },
  '& .input-help-container': {
    margin: '0.3em'
  }
};